import React, { useState, useEffect, useRef } from 'react';
import api from "../../../services/api";
import { store } from "react-notifications-component";
import SelectV2 from "../../select/select_v2";
import SignatureTypeCards from "../../signatureTypeCards";
import Pin from '../../../assets/icons/icons-8-marker@3x.png';
import { ModalRegistrationCompleted, ContainerModal,Footer } from './styles';
import Modal from '../../modal/modalGeneric';
import AddAgronomo from '../../../pages/agronomos/add';
import AddArt from '../../../pages/arts/add';
import EditCreaV2 from '../../../pages/agronomos/editCreaV2';
import ModalUpload from '../../modal/modalUploadCertificado';
import Button from '../../button/button_v2';
import Input from '../../input/input_v2';
import InputV3 from '../../input/novo/input_v3';
import { logout } from '../../../services/auth';
import InputSign from '../../inputSign';
import ModalEmailRegistration from '../../../assets/modal-email-registration.svg';
import ModalGeneric from '../../modal/modalGeneric';
import { BarChart, Bar, XAxis, YAxis, Cell } from 'recharts';
import { ContainerModal as ContratoContainerModal, ButtonPlans as ContratoButtonPlans } from '../../../pages/receitas/styles';

import * as S from './styles';
import { theme } from '../../../styles/theme';
import { TaglineP, Auxiliar, BodyM, H5 } from '../../../styles/stylesTypography';
import { isTotvs, isOmie } from '../../../services/globalFunctions';

import identifyErrorMenssage from "../../../services/identifyErrorMenssage";
export const USER = "@userinfo";


const FormAgronomo = ({ ...props }) => {
    const getTodayDate = () => {
        const today = new Date();
        return today.toISOString().split('T')[0];
    };

    const [responsavel, setResponsavel] = useState('');
    const [disabledResponsavel, setDisabledResponsavel] = useState(false);
    const [erroResponsavel, setErroResponsavel] = useState(false);
    const [responsaveis, setResponsaveis] = useState([]);
    const [showModalAddResponsavel, setShowModalAddResponsavel] = useState(false);
    const [showModalAddCrea, setShowModalAddCrea] = useState(false);
    const [showModalArt, setShowModalArt] = useState(false);
    const [msgErroResponsavel, setMsgErroResponsavel] = useState('');
    const [loadingResponsavel, setLoadingResponsavel] = useState(false);

    const [crea, setCrea] = useState('');
    const [disabledCrea, setDisabledCrea] = useState(true);
    const [erroCrea, setErroCrea] = useState(false);
    const [creas, setCreas] = useState([]);
    const [tipoCrea, setTipoCrea] = useState('');
    const [loadingCreas, setLoadingCreas] = useState(false);
    const [msgErroCrea, setMsgErroCrea] = useState('');

    const [assinatura, setAssinatura] = useState('');
    const [disabledAssinatura, setDisabledAssinatura] = useState(true);
    const [erroAssinatura, setErroAssinatura] = useState(false);
    const [assinaturas, setAssinaturas] = useState([]);
    // A preferência de assinatura agora é salva automaticamente a cada emissão
    // (sem toggle na UI); o backend usa este valor para atualizar agro_creas.assinatura.
    const salvarAssinatura = true;
    const [artAndSignLoading, setArtAndSignLoading] = useState(false);
    const [loadingAssinatura, setLoadingAssinatura] = useState(false);

    const [art, setArt] = useState('');
    const [disabledArt, setDisabledArt] = useState(true);
    const [erroArt, setErroArt] = useState(false);
    const [arts, setArts] = useState([]);
    const [artsIdWithContracts, setArtsIdWithContracts] = useState([]);
    const [showModalAddArt, setShowModalAddArt] = useState(false);
    const [showModalContract, setShowModalContract] = useState(false);
    const [totalContratos, setTotalContratos] = useState(0);
    const [cadastrados, setCadastrados] = useState(0);
    const [previewNumeroArt, setPreviewNumeroART] = useState('');
    const [artForSearch, setArtForSearch] = useState(0);
    const [inicialDate, setInicialDate] = useState(getTodayDate());
    const [endDate, setEndDate] = useState('');
    const [priceContract, setPriceContract] = useState('');
    const [inicialDateError, setInicialDateError] = useState(false);
    const [endDateError, setEndDateError] = useState(false);
    const [priceContractError, setPriceContractError] = useState(false);
    const [loadingCreateContract, setLoadingCreateContract] = useState(false);
    const [dataEmissaoLoading, setDataEmissaoLoading] = useState(false);
    const [msgErroArt, setMsgErroArt] = useState('');
    const [loadingArt, setLoadingArt] = useState(false);

    const [existParams, setExistParams] = useState(false);
    const [params, setParams] = useState([]);

    const [load, setLoad] = useState(false);
    const [messageArt, setMessageArt] = useState('');

    const [showModal, setShowModal] = useState(false);
    const [password, setPassword] = useState('');

    const [dataStepOne, setDataStepOne] = useState('');

    const [erroUser, setErroUser] = useState(true);
    const [showModalUser, setShowModalUser] = useState(false);
    const [loadingUser, setLoadingUser] = useState(false);

    const [user, setUser] = useState('');
    const [pass, setPass] = useState('');
    const [defesa, setDefesa] = useState('');

    const [showModalSign, setShowModalSign] = useState(false);
    const [hasDigitalCertificado, setHasDigitalCertificado] = useState(false);
    const [hasElectronicSignature, setHasElectronicSignature] = useState(false);
    // Guarda o id do responsavel cujas credenciais ja foram consultadas em
    // /sign/consulta. Os cards so sao exibidos depois dessa consulta, para nao
    // mostrarem "Falta enviar o certificado" antes de saber o estado real.
    const [responsavelCredenciaisId, setResponsavelCredenciaisId] = useState(null);

    const { nomeModal, emailModal = '' } = props;
    const [showModalLogged, setShowModalLogged] = useState(false);
    const [nomeId, setNomeId] = useState(nomeModal);
    const [sendEmail, setSendEmail] = useState(false);
    const [emailAgronomo, setEmailAgronomo] = useState(emailModal.trim());
    const [erroNome, setErroNome] = useState(false);
    const [erroNomeMsg, setErroNomeMsg] = useState('Informe o nome do responsável');
    const [erroEmail, setErroEmail] = useState(false);
    const [erroEmailMsg, setErroEmailMsg] = useState('');
    const [whatsapp, setWhatsapp] = useState('');
    const [erroWhatsapp, setErroWhatsapp] = useState(false);
    const [erroWhatsappMsg, setErroWhatsappMsg] = useState('Informe um número válido');

    const [agronomo, setAgronomo] = useState("")
    const [idAgronomo, setIdAgronomo] = useState("")

    const userPLan = JSON.parse(localStorage.getItem("@userinfo"));

    // Controle para executar o prefill apenas uma vez por campo
    const prefillOnce = useRef({ responsavel: false, crea: false, art: false, assinatura: false });
    const blockedContractNotificationKeyRef = useRef('');
    // Ultimo responsavel para o qual /sign/consulta foi disparada.
    const consultaCredenciaisRef = useRef(null);

    const hasRecipeDraft = !!(props?.recipeDraft && Object.keys(props.recipeDraft).length > 0);

    const changeResponsavel = (value) => {
        if (value != responsavel) {
            setCrea('');
            setAssinatura('');
            setArt('');
            setResponsavel(value);
            setIdAgronomo(value.value)

            if (props.producerData?.produtor?.value && props.producerData?.fazenda?.value) {
                getArtWithContracts()
            }
        } else {
        }
    }

    const getArtWithContracts = async () => {
        try {
            const response = await api.get(`/art/${props.producerData?.produtor?.value}/${props.producerData?.fazenda?.value}`);

            if (response) {
                const artId = response.data.agro_art_id;
                setArtsIdWithContracts(artId);
            }
        } catch (error) {
            console.log(error);
        }
    }

    const getDraftResponsavelOption = () => {
        const draft = props.recipeDraft;
        if (!draft || (!draft.agronomo_id && !draft.agronomo_nome)) return null;

        return {
            value: draft.agronomo_id || '',
            label: draft.agronomo_nome || `Agrônomo ${draft.agronomo_id}`,
            cpf: draft.agronomo_cpf || '',
            assinatura: draft.assinatura || '',
            enviar_receita: draft.enviar_receita || 0
        };
    }

    useEffect(() => {
        const draft = props.recipeDraft;

        if (!draft || prefillOnce.current.responsavel) return;

        const hasKeys = draft.agronomo_id || draft.agronomo_nome;
        if (!hasKeys) return;

        if (!loadingResponsavel && Array.isArray(responsaveis) && responsaveis.length > 0 && (responsavel === '' || !responsavel?.value)) {
            let match = null;
            if (draft.agronomo_id) {
                match = responsaveis.find(o => String(o.value) === String(draft.agronomo_id));
            }
            if (!match && draft.agronomo_nome) {
                const nome = String(draft.agronomo_nome).trim().toLowerCase();
                match = responsaveis.find(o => String(o.label).trim().toLowerCase() === nome);
            }
            if (match) {
                changeResponsavel(match);
                prefillOnce.current.responsavel = true;
            }
        }
    }, [props.recipeDraft, responsaveis, loadingResponsavel]);

    // Prefill CREA/CFTA: se houver única opção carregada após selecionar o responsável
    useEffect(() => {
        if (prefillOnce.current.crea) return;
        if (!loadingCreas && Array.isArray(creas) && creas.length > 0 && (crea === '' || !crea?.value)) {
            if (creas.length === 1) {
                changeCrea(creas[0]);
                prefillOnce.current.crea = true;
            }
        }
    }, [creas, loadingCreas, crea]);

    // Prefill ART/TRT: se houver única opção ou se artsIdWithContracts corresponder
    useEffect(() => {
        if (prefillOnce.current.art) return;
        if (!loadingArt && Array.isArray(arts) && arts.length > 0 && (art === '' || !art?.value)) {
            let found = null;
            if (arts.length === 1) {
                found = arts[0];
            } else if (artsIdWithContracts) {
                found = arts.find(a => String(a.value) === String(artsIdWithContracts));
            }
            if (found) {
                changeArt(found);
                prefillOnce.current.art = true;
            }
        }
    }, [arts, loadingArt, art, artsIdWithContracts]);

    // Prefill Tipo de Assinatura: se houver única opção e ainda não definida
    useEffect(() => {
        if (prefillOnce.current.assinatura) return;
        const hasAssinatura = assinatura && (assinatura.value || typeof assinatura === 'string');
        if (!loadingAssinatura && Array.isArray(assinaturas) && assinaturas.length > 0 && !hasAssinatura) {
            if (assinaturas.length === 1) {
                changeAssinatura(assinaturas[0]);
                prefillOnce.current.assinatura = true;
            }
        }
    }, [assinaturas, assinatura, loadingAssinatura]);

    useEffect(() => {
        // Encontrar a art correspondente ao artsIdWithContracts
        const foundArt = arts.find(art => art.value === artsIdWithContracts);
        
        // Se encontrou, atualiza o estado art
        if (foundArt) {
            setArt(foundArt);
        }
    }, [arts, artsIdWithContracts]);

    useEffect(() => {
        if (!showModalContract) return;
        const emissao = String(props.dataEmissao || '');
        if (!emissao) return;
        if (emissao.includes('-')) {
            setInicialDate(emissao.slice(0, 10));
        }
    }, [showModalContract, props.dataEmissao]);

    const formatAgronomos = (values) => {
        let agronomos = [];

        values.map((agr) => {
            agronomos = [...agronomos, {
                value: agr.id, 
                label: agr.nome, 
                cpf: agr.cpf,
                assinatura: agr.assinatura,
                enviar_receita: agr.enviar_receita
            }];
        });

        return agronomos;
    }

    const getAgronomos = async () => {
        setLoad(true);
        try {
            setErroResponsavel(false);
            setDisabledResponsavel(true);
            setLoadingResponsavel(true);

            const draftResponsavel = getDraftResponsavelOption();
            if (draftResponsavel) {
                setResponsaveis([draftResponsavel]);
                if (responsavel === '' || !responsavel?.value) {
                    changeResponsavel(draftResponsavel);
                }
                setDisabledResponsavel(false);
                setLoadingResponsavel(false);
                return;
            }

            const response = await api.get(`/agronomos/estado/${props.estado.value}`);

            if (response) {
                let agronomos = response.data.data;
                agronomos = formatAgronomos(agronomos);
                setResponsaveis(agronomos);
                if (existParams) {
                    if (responsavel === '') {
                        changeResponsavel(params.responsavel);
                    }
                }
            }
            setDisabledResponsavel(false);
            setLoadingResponsavel(false);


        } catch (error) {

            setErroResponsavel(true);
            setMsgErroResponsavel(`${error.response.data.errors}`);
            setDisabledResponsavel(false);
            setLoadingResponsavel(false);

            store.addNotification({
                title: "Erro!",
                message: identifyErrorMenssage(error),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });
        }
    }

    const addNewResponsavel = () => {
        setShowModalAddResponsavel(true);
    }

    const addNewCrea = () => {
        setShowModalAddCrea(true);
    }

    const updateCrea = async () => {
        setShowModalAddCrea(false);
        await getCreas(responsavel.value);
    }

    const formatSign = (value) => {
        let sign = [];

        if (value.digital === true) {
            sign = [...sign, {value: 'D', label: 'Digital'}];
        }
        if (value.eletronica === true) {
            sign = [...sign, {value: 'E', label: 'Eletrônica'}];
        }
        if (value.manual === true) {
            sign = [...sign, {value: 'M', label: 'Manual'}];
        }

        return sign;
    }

    // As assinaturas aceitas sao definidas pelo estado da receita (step 1), nao
    // pelo estado do CREA do responsavel. O CREA fica so como fallback.
    const estadoReceita = typeof props.estado === 'string'
        ? props.estado
        : (props.estado?.value || crea?.estado || '');

    const getSign = async () => {
        if (!estadoReceita) return;

        setLoad(true);
        setLoadingAssinatura(true);
        try {
            const response = await api.get(`/sign/estado/${estadoReceita}`);
            let user = JSON.parse(localStorage.getItem(USER));

            if (user.contrato) {

                if (user.contrato.agro_plan_functions) {

                    let isBlock = false;

                    user.contrato.agro_plan_functions.map((e) => {
                        if (e.agro_plans_function.id === 9) {
                            if (e.status === 0) {
                                isBlock = true;
                            }
                        }
                    });

                    if (isBlock === true) {
                        setAssinaturas([
                            {value: 'M', label: 'Manual'}
                        ]);
                        setLoadingAssinatura(false);

                    } else {
                        if (response) {
                            let sign = response.data.data;
                            sign = formatSign(sign);
                            setAssinaturas(sign);
                            setLoadingAssinatura(false);
                        }
                    }
                } else {
                    logout();
                    window.location = '/login';
                }
            } else {
                logout();
                window.location = '/login';
            }

        } catch (error) {
            setErroAssinatura(true);
            setLoadingAssinatura(false);

            store.addNotification({
                title: "Erro!",
                message: identifyErrorMenssage(error),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });
        }
    }


    const formatCreas = (values) => {
        let creas = [];

        values.map((c) => {
            creas = [...creas, { value: c.id, label: c.crea, tipo: c.tipo, estado: c.estado, arts: c.arts || [], assinatura: c.assinatura }];
        });

        return creas;
    }

    const getCreas = async (id) => {
        try {
            setLoadingCreas(true);
            setDisabledCrea(true);

            const response = await api.get(`/agronomos/${id}/creas?estado=${props.estado.value || props.estado}`);

            if (response) {
                let creas = response.data.data;

                creas = formatCreas(creas);
                setCreas(creas);

                if (existParams) {
                    if (crea === '') {
                        changeCrea(params.crea);
                    }
                }
            }

            setDisabledCrea(false);
            setLoadingCreas(false);

        } catch (error) {
            setLoadingCreas(false);
            setErroCrea(true);
            setDisabledCrea(false);
            setMsgErroCrea(`${error.response.data.errors}`);
            store.addNotification({
                title: "Erro!",
                message: identifyErrorMenssage(error),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });
        }
    }

    const changeCrea = (value) => {
        if (value != crea) {
            setAssinatura('');
            setArt('');
            setCrea(value);
            setTipoCrea(value.tipo);
        } else {
        }
    }

    const changeAssinatura = (value) => {
        if (value != assinaturas) {
            if (value === 'D') {
                setAssinatura({value: 'D', label: 'Digital'});
            } else if (value === 'E') {
                setAssinatura({value: 'E', label: 'Eletrônica'});
            } else if (value === 'M') {
                setAssinatura({value: 'M', label: 'Manual'});
            } else {
                setAssinatura(value);
            }
        } else {
        }
    }

    const formatArts = (values) => {
        let arts = [];
        values.map((a) => {
            if (Number(a.status) !== 1) return;
            arts = [...arts, { 
                value: a.id, 
                label: `${a.apelido ? `${a.numero_art} - ${a.apelido}` : a.numero_art}`, 
                contratos: a.contratos || [] }];
        });

        return arts;
    }

    const getArtsAndPreferentialSign = async (forceRemote = false) => {
        try {
            setArtAndSignLoading(true);
            setDisabledArt(true);
            setLoadingArt(true);
            const currentArtValue = art?.value || art;

            const artResponse = (!forceRemote && crea?.arts && Array.isArray(crea.arts))
                ? { assinatura: crea.assinatura, arts: crea.arts }
                : (await api.get(`/creas/${crea.value}`)).data.data;

            if (artResponse) {
                if (artResponse.assinatura) {
                    if (existParams) {
                        if (assinatura === '') {
                            setAssinatura(params.assinatura?.value || '');
                        }
                    } else {
                        setAssinatura(artResponse.assinatura);
                    }
                } else {
                    if (existParams) {
                        if (assinatura === '') {
                            setAssinatura(params.assinatura?.value || '');
                        }
                    } else {
                        setAssinatura('M');
                    }
                }
                if (crea.estado != 'RJ') {
                    if (artResponse.arts.length > 0) {
                        let arts = formatArts(artResponse.arts);
                        setArts(arts);

                        const hasCurrentArt = currentArtValue !== '' && currentArtValue !== null && currentArtValue !== undefined;
                        if (hasCurrentArt) {
                            const currentArtOption = arts.find((option) => String(option.value) === String(currentArtValue));
                            if (currentArtOption) {
                                setArt(currentArtOption);
                            } else {
                                setArt('');
                            }
                        }

                        if (existParams) {
                            if (art === '') {
                                changeArt(params.art || '');
                            }
                        }
                    } else {
                        setArt('')
                        setArts([])
                        setErroArt(true);
                        store.addNotification({
                            title: "Erro!",
                            message: `O CREA/CFTA selecionado não possui nenhuma ART vinculada a ele. \nCadastre uma nova ART para continuar!`,
                            type: "danger",
                            insert: "top",
                            container: "top-right",
                            animationIn: ["animated", "fadeIn"],
                            animationOut: ["animated", "fadeOut"],
                            dismiss: {
                                duration: 7000,
                                onScreen: true
                            }
                        });
                        setMsgErroArt("Nenhuma ART/TRT cadastrada!")
                    }
                }
            }

            setArtAndSignLoading(false);
            setDisabledArt(false);
            setDisabledAssinatura(false);
            setLoadingArt(false);

        } catch (error) {
            setArtAndSignLoading(false);
            setLoadingArt(false);

            if (error.response.data.errors) {
                store.addNotification({
                    title: "Erro!",
                    message: identifyErrorMenssage(error),
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 4000,
                        onScreen: true
                    }
                });
            }
        }
    }

    const toISODateModal = (value) => {
        if (!value) return null;
        const s = String(value);
        if (s.includes('T')) return s.slice(0, 10);
        if (s.includes('/')) {
            const [d, m, y] = s.split('/');
            if (!y || !m || !d) return null;
            return `${y}-${m.padStart(2, '0')}-${d.padStart(2, '0')}`;
        }
        if (s.includes('-')) return s.slice(0, 10);
        return null;
    };

    const notifyContratoDateError = (message) => {
        store.addNotification({
            title: "Erro!",
            message,
            type: "danger",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: {
                duration: 6000,
                onScreen: true
            }
        });
    };

    const formatCurrency = (value) => {
        const numeric = String(value || '').replace(/\D/g, '');
        const number = parseFloat(numeric) / 100;
        if (isNaN(number)) return '';
        return number.toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
            minimumFractionDigits: 2
        });
    };

    const unformatCurrency = (formattedValue) => {
        if (!formattedValue) return 0;
        return parseFloat(
            String(formattedValue)
                .replace(/[R$\s]/g, '')
                .replace(/\./g, '')
                .replace(',', '.')
        );
    };

    const createContractFromModal = async () => {
        let hasError = false;
        const emissaoISO = toISODateModal(props.dataEmissao);
        const inicioISO = toISODateModal(inicialDate);
        const fimISO = toISODateModal(endDate);

        if (!inicialDate) {
            setInicialDateError(true);
            hasError = true;
        }

        if (!endDate) {
            setEndDateError(true);
            hasError = true;
        }

        if (!String(priceContract || '').trim()) {
            setPriceContractError(true);
            hasError = true;
        }

        if (emissaoISO && inicioISO && emissaoISO < inicioISO) {
            setInicialDateError(true);
            hasError = true;
            notifyContratoDateError("A data de emissão da receita deve ser maior ou igual à data de início do contrato.");
        }

        if (emissaoISO && fimISO && emissaoISO > fimISO) {
            setEndDateError(true);
            hasError = true;
            notifyContratoDateError("A data de emissão da receita deve ser menor ou igual à data final do contrato.");
        }

        if (hasError) return;

        setLoadingCreateContract(true);
        try {
            const payload = {
                agro_art_id: art?.value,
                data_inicio: inicialDate,
                data_termino: endDate,
                valor_contrato: unformatCurrency(priceContract),
                nome_produtor: props.producerData?.produtor?.label,
                agro_farm_id: props.producerData?.fazenda?.value
            };

            await api.post('/contratos', payload);

            store.addNotification({
                title: "Sucesso!",
                message: "Contrato criado com sucesso.",
                type: "success",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });

            setShowModalContract(false);
            setEndDate('');
            setPriceContract('');
            if (crea?.value && artAndSignLoading === false) {
                await getArtsAndPreferentialSign(true);
            }
        } catch (error) {
            const errorMessage = error?.response?.data?.errors || "Erro ao salvar contrato!";
            store.addNotification({
                title: "Erro ao salvar contrato!",
                message: identifyErrorMenssage(error, errorMessage),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 6000,
                    onScreen: true
                }
            });
        } finally {
            setLoadingCreateContract(false);
        }
    };

    useEffect(() => {
        const fetchContractsData = async () => {
            try {
                const response = await api.get(`/contrato/${artForSearch}`);
                const { quantidade_contratos, contratos_cadastrados } = response.data.data;
                setTotalContratos(quantidade_contratos);
                setCadastrados(contratos_cadastrados);
            } catch (error) {
                setTotalContratos(0);
                setCadastrados(0);
            }
        };

        if (artForSearch) fetchContractsData();
    }, [artForSearch]);

    const addNewArt = () => {
        setShowModalAddArt(true);
    }

    const changeArt = (value) => {
        if (value != art) {
            setArt(value);
            const toISODate = (v) => {
                if (!v) return null;
                const s = String(v);
                if (s.includes('T')) return s.slice(0, 10);
                if (s.includes('/')) {
                    const [d, m, y] = s.split('/');
                    if (!y || !m || !d) return null;
                    return `${y}-${m.padStart(2, '0')}-${d.padStart(2, '0')}`;
                }
                if (s.includes('-')) {
                    return s.slice(0, 10);
                }
                return null;
            };

            const emissaoISO = toISODate(props.dataEmissao);
            const farmId = props.producerData?.fazenda?.value;
            const contratos = Array.isArray(value?.contratos) ? value.contratos : [];

            if (props.estado?.value === 'SP' && contratos.length > 0 && farmId) {
                const contratosFarm = contratos.filter(c => String(c.agro_farm_id) === String(farmId));
                const contratosAtivos = contratosFarm.filter(c => c.status === 1);

                if (contratosFarm.length > 0 && contratosAtivos.length === 0) {
                    const blockedContextKey = `${value?.value || ''}-${farmId}-${props.dataEmissao || ''}`;
                    const isoToBR = (iso) => {
                        if (!iso) return '';
                        const [y, m, d] = String(iso).split('-');
                        if (!y || !m || !d) return '';
                        return `${d}/${m}/${y}`;
                    };

                    const ultimoContrato = contratosFarm.reduce((latest, current) => {
                        const latestInicio = toISODate(latest?.data_inicio);
                        const latestFim = toISODate(latest?.data_termino);
                        const currentInicio = toISODate(current?.data_inicio);
                        const currentFim = toISODate(current?.data_termino);

                        if (!latest) return current;
                        if (currentInicio && (!latestInicio || currentInicio > latestInicio)) return current;
                        if (currentInicio === latestInicio && currentFim && (!latestFim || currentFim > latestFim)) return current;
                        return latest;
                    }, null);

                    const inicioBrInativos = isoToBR(toISODate(ultimoContrato?.data_inicio));
                    const terminoBrInativos = isoToBR(toISODate(ultimoContrato?.data_termino));
                    const periodoTxtInativos = inicioBrInativos && terminoBrInativos
                        ? ` (${inicioBrInativos} a ${terminoBrInativos})`
                        : '';

                    if (!(showModalContract && blockedContractNotificationKeyRef.current === blockedContextKey)) {
                        store.addNotification({
                            title: "Erro!",
                            message: `A data de emissão da receita está fora do período do contrato dessa ART${periodoTxtInativos}`,
                            type: "danger",
                            insert: "top",
                            container: "top-right",
                            animationIn: ["animated", "fadeIn"],
                            animationOut: ["animated", "fadeOut"],
                            dismiss: {
                                duration: 7000,
                                onScreen: true
                            }
                        });
                        blockedContractNotificationKeyRef.current = blockedContextKey;
                    }
                    setPreviewNumeroART(value?.label || '');
                    setArtForSearch(value?.value || 0);
                    setShowModalContract(true);
                    return;
                }

                if (!emissaoISO) return;

                const pool = contratosAtivos;

                const ok = pool.some(c => {
                    const ini = toISODate(c.data_inicio);
                    const fim = toISODate(c.data_termino);
                    if (!ini || !fim) return false;
                    return emissaoISO >= ini && emissaoISO <= fim;
                });

                if (!ok && pool.length > 0) {
                    const isoToBR = (iso) => {
                        if (!iso) return '';
                        const [y, m, d] = String(iso).split('-');
                        if (!y || !m || !d) return '';
                        return `${d}/${m}/${y}`;
                    };

                    const range = pool.reduce(
                        (acc, c) => {
                            const ini = toISODate(c.data_inicio);
                            const fim = toISODate(c.data_termino);
                            if (ini && (!acc.minIni || ini < acc.minIni)) acc.minIni = ini;
                            if (fim && (!acc.maxFim || fim > acc.maxFim)) acc.maxFim = fim;
                            return acc;
                        },
                        { minIni: null, maxFim: null }
                    );

                    const inicioBr = isoToBR(range.minIni);
                    const terminoBr = isoToBR(range.maxFim);
                    const periodoTxt = inicioBr && terminoBr ? ` (${inicioBr} a ${terminoBr})` : '';
                    store.addNotification({
                        title: "Erro!",
                        message: `A data de emissão da receita está fora do período do contrato dessa ART${periodoTxt}`,
                        type: "danger",
                        insert: "top",
                        container: "top-right",
                        animationIn: ["animated", "fadeIn"],
                        animationOut: ["animated", "fadeOut"],
                        dismiss: {
                            duration: 8000,
                            onScreen: true
                        }
                    });
                }
            }
        } else {
        }
    }

    const validaAvisoArt = async (artId) => {
        try {
            const responseArt = await api.get(`/arts/aviso/${artId}`);
            if (responseArt.data.data.avisar && responseArt.data.data.avisar == 1) {
                setMessageArt(responseArt.data.message);
                setShowModalArt(true);
            }else if(responseArt.data.data === true){
                setMessageArt(responseArt.data.message);
                setShowModalArt(true);
            }
        } catch (error) {
            setMsgErroArt(`${error.response.data.errors}`);
            store.addNotification({
                title: "Erro!",
                message: identifyErrorMenssage(error),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });
        }
    }

    const loadParams = (params) => {
        setExistParams(true);
        setParams(params);
    }

    const updateAgronomo = () => {
        setShowModalAddResponsavel(false);
        getAgronomos();
    }

    const updateArt = async () => {
        setShowModalAddArt(false);
        await getCreas(responsavel.value);

        if (crea.value && artAndSignLoading === false) {
            await getArtsAndPreferentialSign(true);
        }
    }

    const getPassword = (pass) => {
        setPassword(pass);
    }

    // Consulta previa das credenciais do responsavel (certificado A1 e assinatura
    // eletronica). Diferente de consultaAssinatura, nao abre modal nem notifica
    // erro: quando nao ha credencial o card apenas fica no estado pendente.
    const consultaCredenciaisResponsavel = async (agronomo) => {
        if (!agronomo?.value) return;

        consultaCredenciaisRef.current = agronomo.value;

        const [digital, eletronica] = await Promise.all([
            agronomo.cpf
                ? api.post('/sign/consulta', { cpf: agronomo.cpf }).then(() => true).catch(() => false)
                : Promise.resolve(false),
            api.get(`/sign/consulta/${agronomo.value}`).then(() => true).catch(() => false),
        ]);

        // Troca de responsavel durante a consulta: descarta o resultado antigo.
        if (consultaCredenciaisRef.current !== agronomo.value) return;

        setHasDigitalCertificado(digital);
        setHasElectronicSignature(eletronica);
        setResponsavelCredenciaisId(agronomo.value);
    }

    const consultaAssinatura = async (tipo) => {
        if (tipo === 'D') {
            try {
                const response = await api.post('/sign/consulta', {cpf: responsavel.cpf})
                setHasDigitalCertificado(true);
            } catch (error) {
                setHasDigitalCertificado(false);
                setShowModal(true);
            }
        } else if (tipo === 'E') {
            try {
                const response = await api.get(`/sign/consulta/${responsavel.value}`);
                setHasElectronicSignature(true);
            } catch (error) {
                if (error.response.status === 402) {
                    // Sem assinatura cadastrada apenas marca o card como pendente. A modal
                    // de cadastro so abre pelo botao "Cadastrar assinatura" do banner de
                    // alerta - abrir aqui interrompia o usuario ao selecionar o card.
                    setHasElectronicSignature(false);
                }
            }
        }
    }

    const modalUploadClose = (e) => {
        getPassword(e);
        if (!e || e === undefined) {
            setAssinatura({value: 'M', label: 'Manual'});
        } else {
            setHasDigitalCertificado(true);
        }
        setShowModal(false);
    }

    const getUserHomolog = async (id, estado) => {
        try {
            const response = await api.get(`/agronomos/usuario/${id}/${estado}`);

            if (response) {
                setErroUser(false);
            }
        } catch (error) {
            if (defesa != '') {
                setErroUser(true);
                setShowModalUser(true);
            }
        }
    }

    const saveUser = async () => {
        setLoadingUser(true);
        try {
            const payload = {
                usuario: user,
                senha: pass
            }

            const response = await api.post(`/agronomos/usuario/${responsavel.value}/${props.estado.value}`, payload);

            if (response) {
                setErroUser(false);
                setLoadingUser(false);
                setShowModalUser(false);
            }

        } catch (error) {
            store.addNotification({
                title: "Erro!",
                message: identifyErrorMenssage(error),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });
        }
        setLoadingUser(false);
    }

    const getAgronomoById = async (id) => {
        try {
            const response = await api.get(`/agronomos/${id}`);

            return response.data.data;
        } catch (error) {
            return null;
        }
    }

    const saveSign = async (e) => {
        const agronomoData = await getAgronomoById(responsavel.value);

        try {
            const payload = {
                cpf: responsavel.cpf,
                nome: responsavel.label,
                email: agronomoData?.email || "",
                enviar_receita: responsavel.enviar_receita,
                whatsapp: agronomoData?.whatsapp || "",
                assinatura: e
            };

            const response = api.put(`/agronomos/${responsavel.value}`, payload);

            if (response) {
                setShowModalSign(false);
                setHasElectronicSignature(true);
                store.addNotification({
                    title: "Sucesso!",
                    message: `Assinatura salva com sucesso!`,
                    type: "success",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 4000,
                        onScreen: true
                    }
                });
            }
        } catch (error) {
            store.addNotification({
                title: "Erro!",
                message: identifyErrorMenssage(error),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });
        }
    }

    const clearParamsUser = async (preserveDraftResponsavel = false) => {
        const draftResponsavel = preserveDraftResponsavel ? getDraftResponsavelOption() : null;

        if (draftResponsavel) {
            setResponsaveis([draftResponsavel]);
            changeResponsavel(draftResponsavel);
            prefillOnce.current.responsavel = true;
        } else {
            changeResponsavel('');
            setResponsaveis([]);
        }
        setCreas([]);
        setAssinaturas([]);
        setArts([]);
    }

    const closeModalUser = () => {
        setShowModalUser(false);
        clearParamsUser();
        getAgronomos();
    }

    const getDefesa = async (estado) => {
        try {
            const response = await api.get(`/agronomos/defesa/${estado}`);

            if (response) {
                setDefesa(response.data.data.defesa);
                setErroUser(false);
            }else{
                setDefesa('')
            }

        } catch (error) {
            setDefesa('')
        }
    }

    useEffect(() => {
        if (responsavel) {
            if (responsavel.value) {
                if (loadingCreas === false) {
                    getCreas(responsavel.value);
                }
            }

            if (responsavel.value && defesa != '') {
                getUserHomolog(responsavel.value, props.estado.value);
            } else {
                if (responsavel.value) {
                    setErroUser(false);
                }
            }
        }
    },[responsavel]);

    useEffect(() => {
        setErroCrea(false);
        if (crea.value) {
            if (artAndSignLoading === false) {
                getArtsAndPreferentialSign();
            }
        }

        if (crea.estado) {
            if (crea.estado === 'RJ') {
                changeArt('');
            }
        }
    },[crea]);

    // Os cards de assinatura ficam disponiveis assim que o responsavel tecnico e
    // preenchido, sem depender da escolha do CREA/ART.
    useEffect(() => {
        if (responsavel?.value && estadoReceita) {
            getSign();
            consultaCredenciaisResponsavel(responsavel);
            setDisabledAssinatura(false);
        } else {
            setResponsavelCredenciaisId(null);
        }
    }, [responsavel, estadoReceita]);

    useEffect(() => {
        setDataStepOne(props.dataEmissao);
        if (props.params != undefined) {
            if (props.params.responsavel?.value || props.params.crea?.value || props.params.art?.value || props.params.assinatura?.value) {
                loadParams(props.params);
            }
        } else {
            if (existParams === true) {
                getAgronomos();
            } else if (load === false) {
                getAgronomos();
            }
        }
    },[existParams])

    useEffect(() => {
        if (assinatura.value === 'D' || assinatura.value === 'E') {
            consultaAssinatura(assinatura.value);
        }
    },[assinatura])

    useEffect(()=>{
        if (props.estado?.value && props.estado.value != 'undefined') {
            getDefesa(props.estado.value);
            clearParamsUser(Boolean(getDraftResponsavelOption()));
        }
    }, [props.estado?.value])

    useEffect(() => {
        if (art && load) {
            setErroArt(false);

            if (dataEmissaoLoading === false) {
                validaAvisoArt(art.value);
            }

            if(existParams) {
                setExistParams(false);
            }
        }
    },[art?.value, load]);

    useEffect(() => {
        if (assinatura === 'D' || assinatura === 'E' || assinatura === 'M') {
            changeAssinatura(assinatura);
        } else {
            props.update({responsavel, crea, assinatura, salvarAssinatura, art, erroResponsavel, erroCrea, erroAssinatura, erroArt, password, erroUser});
        }

    },[responsavel, crea, assinatura, art, salvarAssinatura, erroResponsavel, erroCrea, erroAssinatura, erroArt, password, erroUser]);

    const getAgronomoId = async () => {
        try {
            const response = await api.get(`/agronomos/email/${idAgronomo}`);
            const agronomoData = response.data.data

            setAgronomo(agronomoData);
            ModalAgronomoRegistration(agronomoData)
        } catch (error) {
        }
    };

    const ModalAgronomoRegistration = (agronomo) => {
        if (agronomo && agronomo.nome) {
            setShowModalLogged(true);
        } else {
            setShowModalLogged(false);
        }
    };

    const validateNome = nomeId => {
        setNomeId(nomeId);
        setErroNome(false);
    };

    const validateEmail = (emailId) => {
        const trimmedEmail = emailId.trim();
        setEmailAgronomo(trimmedEmail);

        const emailRegex = /^[^\s@]+@[^\s@]+\.[a-zA-Z]+(\.[a-zA-Z]+)*$/;
    
        if (trimmedEmail !== "") {
            const isValidEmail = emailRegex.test(trimmedEmail);
    
            setErroEmail(!isValidEmail);
            setErroEmailMsg(!isValidEmail ? "Informe um e-mail válido" : "");
    
            return isValidEmail;
        } else {
            setErroEmail(false);
            setErroEmailMsg("");
            return true;
        }
    };

    const validateWhatsapp = (numero) => {
        const telefoneNumeros = numero.replace(/\D/g, '');
    
        if (telefoneNumeros !== "") {
            const isValidTelefone = telefoneNumeros.length === 10 || telefoneNumeros.length === 11;
    
            setErroWhatsapp(!isValidTelefone);
            setErroWhatsappMsg(!isValidTelefone ? 'Informe um número válido' : '');
    
            return isValidTelefone;
        } else {
            setErroWhatsapp(false);
            setErroWhatsappMsg("");
            return true;
        }
    };

    const changeWhatsapp = (value) => {
        setWhatsapp(value);
        setErroWhatsapp(false);
        setErroWhatsappMsg('');
    
        validateWhatsapp(value);
    };

    const nextStep = async () => {
        const isEmailValid = emailAgronomo ? validateEmail(emailAgronomo) : true;

        let hasErrors = false;

        if (!nomeId) {
            setErroNome(true);
            store.addNotification({
                title: "Erro!",
                message: "Insira um nome.",
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true,
                },
            });
            hasErrors = true;
        }

        if (emailAgronomo && !isEmailValid) {
            setErroEmail(true);
            setErroEmailMsg("Informe um e-mail válido");
            store.addNotification({
                title: "Erro!",
                message: "E-mail inválido.",
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true,
                },
            });
            hasErrors = true;
        }

        if (whatsapp && (whatsapp.length < 13 || whatsapp.length > 14)) {
            setErroWhatsapp(true);
            store.addNotification({
                title: "Erro!",
                message: "Insira um número válido.",
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true,
                },
            });
            hasErrors = true;
        }else {
            setErroWhatsapp(false); 
        }

        if (hasErrors) {
            return;
        }

        const agronomoDataSend = {
            nome: nomeId,
            email: emailAgronomo,
            whatsapp: whatsapp,
            cpf: responsavel.cpf,
            enviar_receita: responsavel.enviar_receita,
            assinatura: responsavel.assinatura
        };

        const putAgronomosId = async () => {
            try {
                const response = await api.put(`/agronomos/${idAgronomo}`, agronomoDataSend);
                setAgronomo(response.data.data);

                setShowModalLogged(true);
            } catch (error) {
                console.error("Erro ao atualizar o agrônomo:", error);
            }
        };

        await putAgronomosId();
        setShowModalLogged(false);
        store.addNotification({
            title: "Sucesso!",
            message: "Cadastro realizado com sucesso.",
            type: "success",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: {
                duration: 4000,
                onScreen: true,
            },
        });
    };


    useEffect(() => {
        if(idAgronomo){
            getAgronomoId()
        }
    },[idAgronomo])

    const validaArtAssinatura = async (id) => {
        try{
            const response = await api.get(`/art/validar/${id}`)

            if (response?.data?.status === 200){
                return
            }
        } catch (error) {
            store.addNotification({
                title: "Erro!",
                message: identifyErrorMenssage(error),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true,
                },
            });
        }
    }

    useEffect(() => {
        if (art?.value) {
            validaArtAssinatura(art.value)
        }
    },[art])
 
    const contratosDisponiveis = totalContratos - cadastrados;
    const data = [
        {
            name: 'Contratos',
            fundo: totalContratos,
            preenchido: cadastrados
        }
    ];

    return(
        <S.ContainerGeral>
            <SelectV2
                marginBottom='22px'
                name='responsavel_tecnico'
                className="select"
                label="Responsável Técnico"
                labelWithAsterisk={true}
                id='responsavel_tecnico'
                value={responsavel.value || responsavel}
                disabled={disabledResponsavel || (hasRecipeDraft && !isOmie())}
                loading={loadingResponsavel}
                erro={erroResponsavel}
                onChange={(e) => changeResponsavel(e)}
                options={responsaveis}
                selectUniqueOption={existParams ? responsaveis.length === 1 ? true : false : true}
                buttonAddNew={true}
                onClickAddNew={() => addNewResponsavel()}
                messageErro={msgErroResponsavel}
                isModal={true}
                isTotvs={isTotvs()}
            />

            <SelectV2
                marginBottom='22px'
                name='crea_cfta'
                className="select"
                label="CREA/VISTO/CFTA"
                labelWithAsterisk={true}
                id='crea_cfta'
                value={crea.value || crea}
                disabled={disabledCrea}
                loading={loadingCreas}
                erro={erroCrea}
                onChange={(e) => changeCrea(e)}
                options={creas}
                selectUniqueOption={existParams ? creas.length === 1 ? true : false : true}
                buttonAddNew={!!responsavel.value && !disabledCrea}
                onClickAddNew={() => addNewCrea()}
                messageErro={msgErroCrea}
                isModal={true}
            />

            <SelectV2
                marginBottom='22px'
                name='art_trt'
                className="select"
                label="ART/TRT"
                labelWithAsterisk={true}
                id='art_trt'
                value={ art.value || art}
                disabled={ crea.estado === 'RJ' ? true : disabledArt}
                loading={ crea.estado === 'RJ' ? false : loadingArt}
                erro={erroArt}
                onChange={(e) => changeArt(e)}
                options={arts}
                selectUniqueOption={existParams ? arts.length === 1 ? true : false : true}
                buttonAddNew={crea.estado === 'RJ' ? false : !disabledArt}
                legenda={crea.estado === 'RJ' ? 'Não utilizado no estado selecionado!' : ''}
                onClickAddNew={() => addNewArt()}
                messageErro={msgErroArt}
                isModal={true}
            />

            {responsavel?.value && responsavelCredenciaisId === responsavel.value ? (
            <S.ContainerAssinatura>
                <S.ConteudoAssinatura>
                    <TaglineP color={theme.colors.gray.Cinza_2} fontWeight={800} style={{ marginBottom: '8px', display: 'block' }}>
                        <S.AsteriscoObrigatorio>*</S.AsteriscoObrigatorio> Tipo de Assinatura
                    </TaglineP>

                    <SignatureTypeCards
                        value={assinatura.value || assinatura}
                        onChange={(type) => changeAssinatura(type)}
                        allowedSignatures={assinaturas.map((a) => a.value)}
                        estadoValue={estadoReceita}
                        hasDigitalCredential={hasDigitalCertificado}
                        hasElectronicCredential={hasElectronicSignature}
                        disabled={disabledAssinatura || loadingAssinatura}
                        namePrefix="card_radio_assinatura_emissao"
                        responsavelNome={responsavel?.label}
                        onUploadCertificado={() => setShowModal(true)}
                        onCadastrarAssinatura={() => setShowModalSign(true)}
                    />
                </S.ConteudoAssinatura>
            </S.ContainerAssinatura>
            ) : null}

            <S.ContainerFooter>
                <Footer>
                    <img className="pin" src={Pin} alt='estado' />

                    <TaglineP color={theme.colors.gray.Cinza_2} fontWeight={800}>
                        Exibindo resultados para {props.estado.label}
                    </TaglineP>
                </Footer>
            </S.ContainerFooter>

            {showModalAddResponsavel && (
                <Modal
                    size='lg'
                    show={showModalAddResponsavel}
                    onHide={() => setShowModalAddResponsavel(false)}
                >
                    <AddAgronomo
                        isModal={true}
                        update={() => updateAgronomo()}
                        estado={props.estado}
                    />
                </Modal>
            )}

            {showModalArt && (
                <Modal
                    size='lg'
                    show={showModalArt}
                    onHide={()=>setShowModalArt(false)} 
                >
                    <h4 style={{
                        width: '100%',
                        marginTop: '10px',
                        textAlign: 'center'
                    }}>
                        ATENÇÃO!
                    </h4>

                    <p style={{
                        width: '100%',
                        textAlign: 'center'
                    }}>
                        {messageArt}
                    </p>

                    <div className="button-finish" style={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', marginTop: '10px', marginBottom: '10px' }}>
                        <Button
                            width='170px'
                            height='40px'
                            value='OK'
                            outline={false}
                            disabled={false}
                            onClick={() => setShowModalArt(false)}
                            loading={false}
                            tooltip={true}
                            tooltipMsg={''}
                        />
                    </div>
                </Modal>
            )}

            {showModalAddCrea && (
                <Modal
                    size='lg'
                    show={showModalAddCrea}
                    onHide={() => updateCrea()}
                >
                    <EditCreaV2
                        isModal={true}
                        idAgronomo={responsavel.value}
                        onlyCrea={true}
                        estado={props.estado}
                    />
                </Modal>
            )}

            {showModalAddArt && (
                <Modal
                    size='lg'
                    show={showModalAddArt}
                    onHide={() => (setShowModalAddArt(false), getArtsAndPreferentialSign())}
                >
                    <AddArt
                        isModal={true}
                        update={() => updateAgronomo()}
                        estado={crea.estado}
                        agronomo={responsavel}
                        crea={crea}
                        updateArt={() => updateArt()}
                        inicialDateReceita={props.inicialDateReceita}
                    />
                </Modal>
            )}

            {showModalContract && (
                <ModalGeneric
                    show={showModalContract}
                    onHide={() => setShowModalContract(false)}
                    marginBottom='0'
                >
                    <ContratoContainerModal>
                        <H5>Criar novo Contrato</H5>

                        <BodyM color='#303848'>
                            O Produtor selecionado não possui Contrato ativo na ART/TRT selecionada. Preencha os campos abaixo para criar um Contrato:
                        </BodyM>

                        <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem', marginTop: '1.5rem', marginBottom: '0.25rem' }}>
                            <InputV3
                                id="contract_start_date"
                                type="date"
                                label="Selecione Data inicial do Contrato"
                                floatingLabelWithAsterisk="Data inicial do Contrato"
                                value={inicialDate}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    setInicialDate(value);

                                    if (!value) {
                                        setInicialDateError(true);
                                        return;
                                    }

                                    const emissaoISO = toISODateModal(props.dataEmissao);
                                    const inicioISO = toISODateModal(value);

                                    if (emissaoISO && inicioISO && emissaoISO < inicioISO) {
                                        setInicialDateError(true);
                                        notifyContratoDateError("A data de emissão da receita deve ser maior ou igual à data de início do contrato.");
                                    } else {
                                        setInicialDateError(false);
                                    }
                                }}
                                disabled={false}
                                hasError={inicialDateError}
                            />

                            <InputV3
                                id="contract_end_date"
                                type="date"
                                label="Selecione Data final do Contrato (prevista)"
                                floatingLabelWithAsterisk="Data final do Contrato"
                                value={endDate}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    setEndDate(value);
                                    const final = new Date(value);
                                    const inicio = new Date(inicialDate);
                                    const emissaoISO = toISODateModal(props.dataEmissao);
                                    const fimISO = toISODateModal(value);

                                    if (!value) {
                                        setEndDateError(true);
                                    } else if (final < inicio) {
                                        setEndDateError(true);
                                        notifyContratoDateError('A data final do contrato não pode ser menor que a data inicial do contrato.');
                                    } else if (emissaoISO && fimISO && emissaoISO > fimISO) {
                                        setEndDateError(true);
                                        notifyContratoDateError("A data de emissão da receita deve ser menor ou igual à data final do contrato.");
                                    } else {
                                        setEndDateError(false);
                                    }
                                }}
                                hasError={endDateError}
                            />

                            <InputV3
                                type="text"
                                floatingLabelWithAsterisk="Valor estimado do Contrato (R$)"
                                value={priceContract}
                                onChange={(e) => {
                                    const formatted = formatCurrency(e.target.value);
                                    setPriceContract(formatted);
                                    if (formatted.trim()) setPriceContractError(false);
                                }}
                                onKeyDown={(e) => {
                                    const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
                                    const isNumber = /^[0-9]$/.test(e.key);
                                    if (!isNumber && !allowedKeys.includes(e.key)) {
                                        e.preventDefault();
                                    }
                                }}
                                hasError={priceContractError}
                            />
                        </div>

                        <div>
                            {totalContratos > 0 && (
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                    <div style={{ maxWidth: '160px', width: '100%' }}>
                                        <BarChart
                                            width={160}
                                            height={6}
                                            data={data}
                                            layout="vertical"
                                            barSize={4}
                                            style={{ borderRadius: '20px' }}
                                        >
                                            <XAxis type="number" hide domain={[0, totalContratos]} />
                                            <YAxis type="category" dataKey="name" hide />
                                            <Bar dataKey="preenchido" stackId="a" radius={[20, 20, 20, 20]}>
                                                <Cell fill={theme.colors.green.Verde_AgroReceita} />
                                            </Bar>
                                            <Bar dataKey="fundo" stackId="a" radius={[20, 20, 20, 20]}>
                                                <Cell fill={theme.colors.disabled.Fundo_Desabilitado} />
                                            </Bar>
                                        </BarChart>
                                    </div>
                                    <Auxiliar fontWeight="700" style={{ marginTop: '1rem' }}>
                                        {contratosDisponiveis} Contratos disponíveis de {totalContratos}
                                    </Auxiliar>
                                </div>
                            )}

                            <Auxiliar fontWeight='400' color="#586377">ART: {previewNumeroArt}</Auxiliar>
                        </div>

                        <ContratoButtonPlans>
                            <Button
                                width='100%'
                                height='60px'
                                value='Criar Novo Contrato'
                                outline={false}
                                disabled={loadingCreateContract}
                                onClick={createContractFromModal}
                                loading={loadingCreateContract}
                            />
                        </ContratoButtonPlans>
                    </ContratoContainerModal>
                </ModalGeneric>
            )}

            {showModal ? (
                <ModalUpload
                    show={showModal}
                    onHide={(e) => modalUploadClose(e)}
                    cpf={responsavel.cpf}
                    updatePassword={(e) => getPassword(e)}
                />
            ):(null)}

            {showModalUser ? (
                <Modal
                    size='lg'
                    show={showModalUser}
                    onHide={() => closeModalUser()}
                >

                    <div style={{
                        width: '52%',
                        minWidth: '270px',
                        display: 'flex',
                        flexDirection: 'column',
                        margin: 'auto'
                    }}>
                        <p style={{
                            textAlign: 'center'
                        }}>Para emitir receitas para o estado de {props.estado.value} é necessário informar seu usuário e senha de acesso ao {defesa}.</p>

                        <Input
                            marginTop='24px'
                            marginBottom='8px'
                            name="user"
                            type="text"
                            id='userid'
                            label={`Usuário ${defesa}`}
                            onChange={e => setUser(e)}
                            value={user}
                        />

                        <Input
                            name="pass"
                            type='password'
                            id='passid'
                            label={`Senha ${defesa}`}
                            onChange={e => setPass(e)}
                            value={pass}
                        />

                        <div
                            className="containerButton"
                            style={{
                                width: '100%',
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'center',
                                alignItems: 'center',
                                paddingTop: erroArt ? '10px' : '0px',
                            }}
                        >
                            <Button
                                width='200px'
                                height='35px'
                                value='Salvar'
                                outline={true}
                                disabled={false}
                                loading={loadingUser}
                                onClick={() => saveUser()}
                            />
                        </div>
                    </div>

                </Modal>
            ) : (null)}

            {showModalSign ? (
                <Modal
                    size='lg'
                    show={showModalSign}
                    onHide={() => {
                        setShowModalSign(false);
                        changeAssinatura('M')
                    }}
                >
                    <div style={{
                        width: "100%",
                        margin: 'auto',
                        maxWidth: '400px'
                    }}>
                        <InputSign update={(e) => saveSign(e)} />
                    </div>

                </Modal>
            ) : (null)}

            {userPLan.contrato.agro_plan_config.nome_plano !== "TESTE GRÁTIS" ? (
                showModalLogged === !false && (
                    <ContainerModal>
                        <ModalGeneric
                            show={showModalLogged}
                            onHide={() => setShowModalLogged(false)}
                            size='sm'
                        >
                            <ModalRegistrationCompleted>
                                <img src={ModalEmailRegistration} alt="Imagem de mulher atualizando dados."/>

                                <h2>Atualize seu cadastro para receber notificações</h2>

                                <p>Receba nossas notificações quando suas ARTs/TRTs estiverem acabando, alertas de risco climático e mais.</p>

                                <Input
                                    name="nome"
                                    type="text"
                                    label="Nome"
                                    id="nomeId"
                                    onChange={e => validateNome(e)}
                                    erro={erroNome}
                                    messageErro={erroNomeMsg}
                                    value={agronomo.nome}
                                />
                                <Input
                                    id="email"
                                    name="email"
                                    label="E-mail"
                                    onChange={e => validateEmail(e)}
                                    yesNo={false}
                                    messageYesNo={'enviar receitas por email'}
                                    erro={erroEmail}
                                    yesNoSpanWidth={'80px'}
                                    messageErro={erroEmailMsg}
                                    value={emailAgronomo}
                                    onChangeYesNo={(e) => { setSendEmail(e ? 1 : 0); }}
                                />
                                <Input
                                    id="telefone"
                                    label="Whatsapp"
                                    name="telefonecelular"
                                    value={whatsapp}
                                    onChange={e => changeWhatsapp(e)}
                                    erro={erroWhatsapp}
                                    messageErro={erroWhatsappMsg}
                                    inputmode="numeric"
                                />

                                <div className="button-finish"
                                    style={{
                                        width: '100%',
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'center',
                                    }}>
                                    <Button
                                        width='296px'
                                        height='50px'
                                        value='Cadastrar e-mail'
                                        outline={false}
                                        disabled={false}
                                        onClick={() => nextStep()}
                                        loading={false}
                                    />
                                </div>
                            </ModalRegistrationCompleted>
                        </ModalGeneric>
                    </ContainerModal>
                )
            ):("")}
        </S.ContainerGeral>
    )
}

export default FormAgronomo;
